/* Thoson site wide behaviour. Loaded deferred from layout/theme.liquid,
   so the document is fully parsed by the time any of this runs. */
(function () {
  'use strict';

  var THX_ES = /^es\b/i.test(document.documentElement.lang || '');
  var THX_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ----------------------------------------------------------------
     Collection, search and index cards.

     A product with variants renders its card button inside <modal-opener>,
     which pops a small variant picker over the grid: no gallery, no reviews,
     no bundles, no shipping estimate. Those buttons now go to the product
     page instead. A product with a single variant keeps its card form and
     still adds to the cart in one tap, so this only changes the case that
     was interrupting the visit.

     The listener runs on document in the capture phase, which fires before
     modal-opener's own handler, and stopPropagation keeps the modal from
     opening at all. It is bound once and works for cards rendered later by
     filters, pagination or the theme editor.
     ---------------------------------------------------------------- */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('button[data-product-url]');
      if (!button || !button.closest('modal-opener')) return;

      var url = button.getAttribute('data-product-url');
      if (!url) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.href = url;
    },
    true
  );

  /* ----------------------------------------------------------------
     Product page: the collection nav strip.

     The strip is a Custom Liquid block inside a section_divider section near
     the bottom of the page, and that same section draws the decorative wave
     that belongs directly above the blue band under it. Reordering the whole
     section, which is how this was done first, dragged the wave along with
     it and left it stranded above the ticker.

     So only the strip travels. It is appended to the buy box under the last
     accordion, and the section keeps its wave exactly where the design put
     it. The CSS keeps the strip invisible until this has placed it, so it
     never flashes at the bottom of the page first.
     ---------------------------------------------------------------- */
  function placeCollectionNav() {
    var box = document.querySelector('.product__info-container');
    var nav = document.querySelector('.tn-dyn-section');
    if (!box || !nav) return;
    if (nav.classList.contains('thx-in-buybox') && box.contains(nav)) return;

    var accordions = box.querySelectorAll('.product__accordion');
    if (accordions.length) {
      accordions[accordions.length - 1].insertAdjacentElement('afterend', nav);
    } else {
      box.appendChild(nav);
    }
    nav.classList.add('thx-in-buybox');
  }

  /* ----------------------------------------------------------------
     Product page: the story videos in the buy box.

     The page already carries three vertical videos in an image slider far
     below the fold, past every proof block, where most of the traffic never
     reaches. The same three are cloned into the buy box, above the first
     accordion and under the icon row, at story size: the toy in use sits
     next to the price instead of eight screens below it.

     Clones, not a move, so the slider underneath stays exactly as it is.
     They carry preload="none" and only start once they are on screen, so
     three extra videos in the buy box cost nothing until somebody sees
     them. Muted, looping and inline, which is what a phone allows to play
     on its own, y nada mas: no se tocan, no abren nada, se ven y ya.

     The theme lazy loads its videos: the mp4 lives in data-src on the
     <source> and only becomes src once the slider is near the viewport, so
     this has to read both or it finds nothing at load.
     ---------------------------------------------------------------- */
  var STORY_SOCIAL = THX_ES ? 'Más de 5M de vistas en Instagram' : 'Over 5M views on Instagram';

  function placeStoryVideos() {
    var box = document.querySelector('.product__info-container');
    if (!box || box.querySelector('.thx-stories')) return;

    var slider = document.querySelector('#MainContent [id*="image_slider"]');
    if (!slider) return;

    var slides = slider.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    var clips = [];
    Array.prototype.forEach.call(slides, function (slide) {
      var video = slide.querySelector('video');
      var source = video && video.querySelector('source');
      var src = source && (source.getAttribute('src') || source.getAttribute('data-src'));
      if (!src) return;
      clips.push({
        src: src,
        type: source.getAttribute('type') || 'video/mp4',
        poster: video.getAttribute('poster') || ''
      });
    });
    if (clips.length < 2) return;

    var block = document.createElement('div');
    block.className = 'thx-stories';

    var chip = document.createElement('span');
    chip.className = 'thx-stories__chip';
    chip.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3.2" y="3.2" width="17.6" height="17.6" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.2" cy="6.8" r="1.1"></circle></svg>';
    chip.appendChild(document.createTextNode(STORY_SOCIAL));
    block.appendChild(chip);

    var row = document.createElement('div');
    row.className = 'thx-stories__row';

    clips.slice(0, 3).forEach(function (clip) {
      var card = document.createElement('div');
      card.className = 'thx-stories__card';

      var video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'none');
      video.setAttribute('disablepictureinpicture', '');
      if (clip.poster) video.setAttribute('poster', clip.poster);

      var source = document.createElement('source');
      source.setAttribute('src', clip.src);
      source.setAttribute('type', clip.type);
      video.appendChild(source);

      card.appendChild(video);
      row.appendChild(card);
    });

    block.appendChild(row);

    var accordion = box.querySelector('.product__accordion');
    if (accordion) box.insertBefore(block, accordion);
    else box.appendChild(block);

    if (!window.IntersectionObserver) return;
    var watcher = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (!entry.isIntersecting) {
            video.pause();
            return;
          }
          if (video.getAttribute('preload') === 'none') video.setAttribute('preload', 'auto');
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        });
      },
      { threshold: 0.4 }
    );
    Array.prototype.forEach.call(row.querySelectorAll('video'), function (video) {
      watcher.observe(video);
    });
  }

  /* ----------------------------------------------------------------
     Product page: the shipping bar.

     It used to read "Shipped FREE via Air between Monday, September 21st
     and Wednesday, September 23rd" over two lines: two long dates and a
     sentence the customer has to decode. It now carries the two things
     that actually decide the sale, on one line: there is stock, and it
     leaves fast.

     Sold out is read off the theme's own sold out price badge, which it
     prints and hides per variant, plus the label on the main add button.
     The first version looked at the add to cart button and matched the
     upsell block's button instead, so a sold out product still promised
     stock. Two independent signals now, and the bar hides on either.

     The dates come from the <dynamic-dates> custom element, which writes
     them into the paragraph on its own, and the buy box is re-rendered on
     every variant change, so this is marked with an attribute and an
     observer puts it back whenever the theme brings the old sentence back.
     ---------------------------------------------------------------- */
  var SHIP_STOCK = THX_ES ? 'Disponible' : 'In Stock';
  var SHIP_SPEED = THX_ES ? 'Se envía en 1 día' : 'Shipped within 1 day';

  function isSoldOut() {
    var badge = document.querySelector('.product__info-container .price__badge-sold-out');
    if (badge && badge.offsetParent !== null) return true;
    var label = document.querySelector('.main-atc__label__text, .sticky-atc__label');
    if (label && (THX_ES ? /sold\s*out|agotado/i : /sold\s*out/i).test(label.textContent || '')) return true;
    return false;
  }

  function rewriteShipping() {
    var soldOut = isSoldOut();
    var bars = document.querySelectorAll('dynamic-dates.estimated-shipping');
    Array.prototype.forEach.call(bars, function (bar) {
      if (soldOut) bar.style.setProperty('display', 'none', 'important');
      else bar.style.removeProperty('display');

      if (bar.getAttribute('data-thx-ship') === '1') return;
      var line = bar.querySelector('.estimated-shipping__text p');
      if (!line) return;

      var live = document.createElement('span');
      live.className = 'thx-ship__live';
      live.appendChild(document.createTextNode(SHIP_STOCK));

      var dot = document.createElement('span');
      dot.className = 'thx-ship__sep';
      dot.setAttribute('aria-hidden', 'true');

      line.textContent = '';
      line.appendChild(live);
      line.appendChild(document.createTextNode(' '));
      line.appendChild(dot);
      line.appendChild(document.createTextNode(SHIP_SPEED));

      bar.classList.add('thx-ship');
      bar.setAttribute('data-thx-ship', '1');
    });
  }

  /* ----------------------------------------------------------------
     Prices with no cents.

     Nothing in the catalogue is priced with cents except two accessories,
     so every price on the storefront was reading "$69.00" for what is
     simply 69. Only a trailing .00 is dropped, so the two that really do
     carry cents keep them and nobody is quoted a price they will not be
     charged. Scoped to elements whose class names it a price, a money
     value or a total, so ordinary copy is never touched.
     ---------------------------------------------------------------- */
  var PRICE_ZEROS = /(\d)\.00(?!\d)/g;
  var PRICE_HOLDER = '[class*="price"], [class*="Price"], [class*="money"], [class*="total"]';

  function stripPriceZeros(root) {
    var scope = root && root.nodeType === 1 ? root : document.body;
    if (!scope || !scope.nodeType) return;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.data.indexOf('.00') === -1) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        if (!parent.closest || !parent.closest(PRICE_HOLDER)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var pending = [];
    var node;
    while ((node = walker.nextNode())) pending.push(node);

    pending.forEach(function (text) {
      text.data = text.data.replace(PRICE_ZEROS, '$1');
    });
  }

  /* ----------------------------------------------------------------
     Buy box accordions: the heading said it twice.

     Several products open "What's included?" and the first thing inside is
     an H2 reading WHAT'S INCLUDED again. Not all of them: of the accordions
     on the catalogue, 22 repeat the summary, 6 open with a different heading
     that belongs there and 14 have no heading at all. So this cannot be a
     blanket CSS rule hiding the first heading, it has to compare the two
     strings and only drop the repeat.

     Letters and digits only on both sides, so casing, punctuation and an
     apostrophe that differs between the two do not stop a match.
     ---------------------------------------------------------------- */
  function normalise(text) {
    return (text || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  function dropRepeatedHeadings() {
    var accordions = document.querySelectorAll('.product__info-container .product__accordion');
    Array.prototype.forEach.call(accordions, function (accordion) {
      var summary = accordion.querySelector('.accordion__title');
      var content = accordion.querySelector('.accordion__content');
      if (!summary || !content) return;

      var first = content.firstElementChild;
      if (!first || !/^H[1-6]$/.test(first.tagName)) return;

      var label = normalise(summary.textContent);
      var heading = normalise(first.textContent);
      if (!label || !heading) return;

      if (heading === label || heading.indexOf(label) === 0 || label.indexOf(heading) === 0) {
        first.remove();
      }
    });
  }

  /* ----------------------------------------------------------------
     Empty cart: the call to action.

     The drawer offered "Continue shopping" pointing at /collections/all,
     which is every product in the catalogue and no help at all to somebody
     who just emptied their cart. It now names the shelf worth starting from
     and goes there.

     The href lives inside a 49 KB snippet and the label in a shared locale
     key the 404 page also uses, so both are set here instead.
     ---------------------------------------------------------------- */
  var EMPTY_CART_CTA = THX_ES ? 'Empieza con Nuestros Más Vendidos' : 'Start With Our Best Sellers';
  var EMPTY_CART_URL = THX_ROOT + 'collections/best-sellers';

  function reworkEmptyCartCta() {
    var links = document.querySelectorAll(
      '.cart-drawer__empty-content a.button, .cart__empty-content a.button, .cart__warnings a.button'
    );
    Array.prototype.forEach.call(links, function (link) {
      if (link.getAttribute('data-thx-cta') === '1') return;
      link.setAttribute('href', EMPTY_CART_URL);
      link.textContent = EMPTY_CART_CTA;
      link.setAttribute('data-thx-cta', '1');
    });
  }

  /* ----------------------------------------------------------------
     Em dashes.

     The storefront copy carries them in section settings across the product
     templates, the ticker, the testimonials and the icon bars. Two different
     jobs, so two different fixes.

     Opening a line it is an attribution dash, the one in front of a
     testimonial signature, and it simply goes: turning it into a comma left
     every review credited to ", Sarah M.". That case is recognised by the
     text node being the first thing inside its element, so a dash that
     follows a bold run in the middle of a sentence is not caught by it.

     Anywhere else it is a break in a sentence, and a comma reads the way the
     sentence was meant, so the dash and any comma or semicolon already
     sitting in front of it collapse into one comma.

     Blog articles are left alone on purpose.
     ---------------------------------------------------------------- */
  var EM_DASH_LEADING = /^\s*—\s*/;
  var EM_DASH = /\s*[,;]?\s*—\s*/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1 };

  function stripEmDashes(root) {
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?blogs\//.test(window.location.pathname)) return;

    var scope = root || document.body;
    if (!scope || !scope.nodeType) return;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.data.indexOf('—') === -1) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var pending = [];
    var node;
    while ((node = walker.nextNode())) pending.push(node);

    pending.forEach(function (text) {
      var value = text.data;
      if (!text.previousSibling) value = value.replace(EM_DASH_LEADING, '');
      text.data = value.replace(EM_DASH, ', ');
    });
  }


  /* ----------------------------------------------------------------
     Las tiras de chips: el desvanecido de los bordes.

     El tema desvanece los bordes de las filas que se desplazan, pero solo
     le pone estado a una de ellas. .tn-dyn-nav recibe is-scrolled y
     is-at-end segun donde este el scroll, asi que su borde izquierdo
     aparece solo cuando hay algo escondido detras. .tn-cat-nav y
     .tn-age-nav no reciben nada: llevan el desvanecido izquierdo puesto
     siempre, tambien cuando la fila esta en su primer chip, y ahi lo que
     parece es que el chip esta cortado.

     Esto les da las mismas dos clases. El CSS de thx-collnav.css iguala
     luego los dos lados a 44px, que es lo que ya media el derecho.

     El estado no se mide con scrollLeft. Las filas llevan
     scroll-snap-type: x, y el iman deja la fila en reposo con scrollLeft
     16, no 0, porque encaja el primer chip contra el borde comiendose el
     relleno. Comparar contra cero daba la fila por desplazada nada mas
     cargar, y el borde izquierdo aparecia sin haber tocado nada: justo lo
     que se venia a arreglar. Se mide con geometria contra el borde de la
     caja, que es cierto con iman y sin el: esta al principio mientras el
     primer chip no se haya ido por la izquierda, y al final cuando el
     ultimo ya cabe entero.
     ---------------------------------------------------------------- */
  function edgeFades() {
    var rows = document.querySelectorAll('.tn-cat-nav, .tn-age-nav');
    Array.prototype.forEach.call(rows, function (row) {
      function sync() {
        var first = row.firstElementChild;
        var last = row.lastElementChild;
        if (!first || !last) return;
        var box = row.getBoundingClientRect();
        var atStart = first.getBoundingClientRect().left >= box.left - 2;
        var atEnd = last.getBoundingClientRect().right <= box.right + 2;
        row.classList.toggle('is-scrolled', !atStart);
        row.classList.toggle('is-at-end', atEnd);
      }
      if (row.getAttribute('data-thx-edges') !== '1') {
        row.setAttribute('data-thx-edges', '1');
        row.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync, { passive: true });
      }
      sync();
    });
  }


  /* ------------------------------------------------------------------
     Section 8. Product page: the review score beside the urgency tag.

     The theme ships a rating_stars block for the buy box, but it sits
     disabled in all 40 product templates and the label baked into each
     one reads "4.9 | 4777 Reviews", a figure typed by hand when the
     theme was built. The store's own review data says 4.7 over 147 for
     MagTrack. Turning the block on would mean rewriting 40 templates of
     50KB apiece to publish a number the store cannot back, so the score
     is built here instead, from the only real source the page already
     carries: the review importer's own payload. Import more reviews and
     this rises on its own, with no code touched.

     El tag y la nota dejan de ser dos cosas sueltas y se funden en una
     sola chapa de dos zonas: el mensaje en melocotón claro a la
     izquierda, las cinco estrellas y el número en melocotón tostado a
     la derecha, con los extremos redondeados y sin costura en medio.

     Se construye moviendo el tag dentro de la fila y poniendo la nota a
     su lado; el CSS hace el resto recortando el redondeo de cada
     extremo. El mensaje puede encogerse y la nota nunca, así que en un
     tag largo como el de Quarry el texto se reparte en dos líneas y la
     chapa crece hacia abajo en vez de partirse.

     A product with no imported reviews gets nothing. No pill, no
     placeholder, no zero.
  */

  var RATING_RE = /reviewCountInfo\\?"\s*\\?:\s*\{[\s\S]{0,400}?\\?"total\\?"\s*\\?:\s*(\d+)\s*,\s*\\?"average\\?"\s*\\?:\s*([0-9.]+)[\s\S]{0,80}?product_shopify_id\\?"\s*\\?:\s*\\?"?(\d+)/g;

  var STAR_PATH =
    'M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5' +
    'c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3' +
    's23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3' +
    'L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z';

  function currentProductId() {
    var m = window.meta && window.meta.product;
    if (m && m.id) return String(m.id);
    var sa = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (sa && sa.product && sa.product.id) return String(sa.product.id);
    var hidden = document.querySelector('.product__info-container input[name="product-id"]');
    return hidden && hidden.value ? String(hidden.value) : '';
  }

  /* The payload appears twice on the page and upsell blocks can carry a
     second product's copy of it, so every hit is matched against this
     page's product id before it is believed. */
  function readReviewSummary() {
    var want = currentProductId();
    if (!want) return null;
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || '';
      if (text.indexOf('reviewCountInfo') === -1) continue;
      RATING_RE.lastIndex = 0;
      var hit;
      while ((hit = RATING_RE.exec(text)) !== null) {
        if (hit[3] !== want) continue;
        var total = parseInt(hit[1], 10);
        var average = parseFloat(hit[2]);
        if (total > 0 && average > 0 && average <= 5) {
          return { total: total, average: average };
        }
      }
    }
    return null;
  }

  function starLayer(className) {
    var svg = '<svg viewBox="0 0 576 512" aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '"></path></svg>';
    return '<span class="' + className + '">' + svg + svg + svg + svg + svg + '</span>';
  }

  function buyBoxRating() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    if (info.querySelector('.thx-rating')) return;

    var summary = readReviewSummary();
    if (!summary) return;

    var tag = info.querySelector('.urgency-text');
    var title = info.querySelector('.product__title');
    var anchor = tag || title;
    if (!anchor) return;

    /* Every product template sets its own margins on the urgency tag
       (MagTrack 20/12, Pippo 0/12), so the row inherits whatever that
       product had instead of a figure hard coded here. Zeroing the tag
       and hard coding 20/12 would shift the title on every product that
       was not set up like MagTrack. */
    var tagStyle = tag ? window.getComputedStyle(tag) : null;

    var row = document.createElement('div');
    row.className = tag ? 'thx-rating-row' : 'thx-rating-row thx-rating-row--solo';
    if (tagStyle) {
      row.style.marginTop = tagStyle.marginTop;
      row.style.marginBottom = tagStyle.marginBottom;
    }
    anchor.parentNode.insertBefore(row, anchor);
    if (tag) row.appendChild(tag);

    var score = summary.average.toFixed(1);
    var count = summary.total.toLocaleString('en-US');
    var noun = summary.total === 1 ? 'review' : 'reviews';
    if (THX_ES) noun = summary.total === 1 ? 'reseña' : 'reseñas';
    var pct = Math.max(0, Math.min(100, (summary.average / 5) * 100));

    /* Cinco estrellas rellenas al porcentaje exacto de la nota: un 4.7
       pinta el 94 % de la fila, no cuatro y media redondeadas. La cuenta
       de reseñas no se dibuja, pero viaja en el aria-label, así que un
       lector de pantalla la sigue oyendo entera. */
    var el = document.createElement('span');
    el.className = 'thx-rating';
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', score + (THX_ES ? ' de 5 estrellas, ' : ' out of 5 stars, ') + count + ' ' + noun);
    el.innerHTML =
      '<span class="thx-rating__stars">' +
        starLayer('thx-rating__bg') +
        '<span class="thx-rating__fg" style="width: ' + pct.toFixed(2) + '%;">' +
          starLayer('thx-rating__fill') +
        '</span>' +
      '</span>' +
      '<span class="thx-rating__score">' + score + '</span>';
    row.appendChild(el);
  }

  function runAll(root) {
    placeCollectionNav();
    edgeFades();
    placeStoryVideos();
    buyBoxRating();
    rewriteShipping();
    stripPriceZeros(root);
    dropRepeatedHeadings();
    reworkEmptyCartCta();
    stripEmDashes(root);
  }

  runAll();

  /* The theme editor re-renders a section into fresh markup, which puts a new
     strip back at the bottom and brings back the copy this pass cleaned. */
  document.addEventListener('shopify:section:load', function (event) {
    runAll(event && event.target);
  });

  /* A variant change re-renders the buy box and a filter re-renders the
     product grid, neither of which fires a section load event. Only the two
     passes that read live prices and stock run here, debounced onto a frame,
     and both are idempotent so they cannot chase their own writes. */
  var main = document.getElementById('MainContent');
  if (main && window.MutationObserver) {
    var mainQueued = false;
    new MutationObserver(function () {
      if (mainQueued) return;
      mainQueued = true;
      requestAnimationFrame(function () {
        mainQueued = false;
        buyBoxRating();
        rewriteShipping();
        stripPriceZeros(main);
      });
    }).observe(main, { childList: true, subtree: true });
  }

  /* Shopify replaces the whole cart drawer on every cart change, which puts
     the stock empty state back. Debounced onto a frame so a burst of
     mutations costs one pass. */
  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        reworkEmptyCartCta();
        stripPriceZeros(drawer);
        stripEmDashes(drawer);
      });
    }).observe(drawer, { childList: true, subtree: true });
  }
})();